<template>
    <li class="flex flex-col min-w-full min-h-full col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm saturate-100 hover:saturate-200 rounded-t-2xl">
        <div class="flex flex-col flex-1 px-8 py-6 space-y-3">
            <a :href="`/theatre-companies/${company.intId}/${company.slug}`"
               :alt="company.name"
               :title="company.name" class="guide-img-container"> 
                <img class="mx-auto shrink-0 rounded-2xl max-h-32"
                     :src="company.logoUrl"
                     :alt="company.name"
                     :title="company.name">
            </a>
            <a :href="`/theatre-companies/${company.intId}/${company.slug}`"
               :alt="company.name"
               :title="company.name"
               class="text-lg font-medium text-gray-900 hover:underline hover:decoration-slate-900 hover:transition-all hover:decoration-2">
                <h3 class="text-xl">{{ company.name }}</h3>
            </a>
            <p v-if="company.shortAddressPrettified?.length > 0"
               class="mb-2 text-sm text-slate-600">
                {{ company.shortAddressPrettified }}
            </p>
            <dl class="flex flex-col justify-between flex-grow mt-1">
                <dd v-if="company.isNoLongerActive"
                    class="px-3 py-2 my-3 text-xs font-bold text-center uppercase rounded-lg bg-slate-200 text-clay-700">
                    No longer active
                </dd>

                <dt class="sr-only">Types</dt>
                <dd class="text-sm text-clay-800">{{ company.types?.join(", ") }}</dd>

            </dl>

            <div v-if="company.opportunityCount"
                 class="justify-center flex items-center gap-x-1.5"
                 title="This entity has active opportunities">
                <div class="flex-none p-1 rounded-full bg-emerald-500/20">
                    <div class="h-1.5 w-1.5 rounded-full bg-emerald-500"></div>
                </div>
                <p class="text-xs leading-5 text-clay-800">
                    <a :href="`/theatre-companies/${company.intId}/${company.slug}#opportunities`"
                       :alt="`Opportunities for ${company.name}`"
                       :title="`Opportunities for ${company.name}`"
                       class="border-b hover:border-none">
                        {{ company.opportunityCount }} active
                        <span v-if="company.opportunityCount === 1">opportunity</span>
                        <span v-else>opportunities</span>
                    </a>
                </p>
            </div>

            <div v-if="company.alumniCount"
                 class="justify-center flex items-center gap-x-1.5"
                 title="This entity has active alumni">
                <div class="flex-none p-1 rounded-full bg-clay-200/20">
                    <div class="h-1.5 w-1.5 rounded-full bg-clay-500"></div>
                </div>
                <p class="text-xs leading-5 text-clay-800">
                    <a :href="`/theatre-companies/${company.intId}/${company.slug}#alumni`"
                       :alt="`Alumni for ${company.name}`"
                       :title="`Alumni for ${company.name}`"
                       class="border-b hover:border-none">
                        {{ company.alumniCount }} <span v-if="company.alumniCount === 1">alumnus</span>
                        <span v-else>alumni</span>
                    </a>
                </p>
            </div>

            <div class="flex justify-center pt-6 text-sm ">
                <fanning :id="company.id" :number-of-fans="company.fanCount"></fanning>
                <Bookmarking :id="company.id"></Bookmarking>
            </div>
        </div>


    </li>


</template>
<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, Ref, ref} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {TheatreCompanyDTO} from "@/dtos";

const props = defineProps({
    company: {},
})

const company: TheatreCompanyDTO = props.company;

</script>
<style>

</style>